import WorkingHistory from "../components/pages/Home/WorkingHistory";
import WorkerManage from "../components/pages/Home/WorkerManage";
import SiteManage from "../components/pages/Home/SiteManage";
import TypeManage from "../components/pages/Home/TypeManage";
import Analyze from '../components/pages/Home/Analyze'
import History from '@material-ui/icons/History';
import Terrain from '@material-ui/icons/Terrain';
import Sort from '@material-ui/icons/Sort';
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';
import BarChart from "@material-ui/icons/BarChart";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Info from "@material-ui/icons/Info";
import Person from "@material-ui/icons/Person";
import SafetyInfomation from "../components/pages/Home/SafetyInfomation";
import AdminProfile from "../components/pages/Home/AdminProfile";

const homeRoutes = [
    {
      path: "/home/history",
      sidebarName: "Working History",
      navbarName: "Working History",
      icon: History,
      component: WorkingHistory
    },
    {
      path: "/home/worker",
      sidebarName: "Worker Management",
      navbarName: "Worker Management",
      icon: SupervisorAccount,
      component: WorkerManage
    },
    {
      path: "/home/site",
      sidebarName: "Site Information",
      navbarName: "Site Information",
      icon: Terrain,
      component: SiteManage
    },
    {
      path: "/home/type",
      sidebarName: "Job Type",
      navbarName: "Job Type",
      icon: Sort,
      component: TypeManage
    },
    {
      path: "/home/analyze",
      sidebarName: 'Analysis',
      navbarName: "Analysis",
      icon: BarChart,
      component: Analyze
    },
    {
      path: "/home/safety",
      sidebarName: 'H&S Delivery Record',
      navbarName: "H&S Delivery Record",
      icon: Info,
      component: SafetyInfomation
    },
    {
      path: "/home/update",
      sidebarName: "Admin Profile",
      navbarName: "Profile",
      icon: Person,
      component: AdminProfile
    },
    {
      path: "/home/logout",
      sidebarName: "Log Out",
      navbarName: "Log Out",
      icon: ExitToApp,
      component: WorkingHistory
    },
    { redirect: true, path: "/home", to: "/home/history", navbarName: "Redirect" }
];

export default homeRoutes

  